/* eslint-disable */ import { assertString, memoEval, textValueComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const solidColorMaterialComponents = [
    attachAdminComponent.withComponent(textValueComponent, 'name', true).withAlias('SolidColorMaterial').attach(memoEval((self)=>[
            self.name
        ], (name)=>({
            value: name
        })), (state)=>{
        assertString(state.value);
        return {
            name: state.value
        };
    }),
    attachAdminComponent.withComponent(textValueComponent, 'color', true).withAlias('SolidColorMaterial').attach(memoEval((self)=>[
            self.color
        ], (color)=>({
            value: color
        })), (state)=>{
        assertString(state.value);
        return {
            color: state.value
        };
    })
];

//# sourceMappingURL=solid-color-material.js.map